import React , { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import LeftBussinessList from './bussinessList';
import {PolicyAnalyzeCard} from '../../common/index';

import BusinessScopeSty from './bussinessScope.module.css'

import {fetch_bussinessList,fetch_bussinessConData,fetch_bussiness_article} from '../../actions/bussiness/createBussinessListAction';
import {fetch_bussiness_zxzx} from '../../actions/bussiness/createBussinessZXZXAction';
import {fetch_policy_type} from '../../actions/aboutPolicy/policyTypeAction';
import {fetch_policy} from '../../actions/aboutPolicy/policyAction';

import bussiness_policy_img1 from '../../images/bussiness_policy_img1.png';
import bussiness_policy_img2 from '../../images/bussiness_policy_img2.png';
import bussiness_policy_img3 from '../../images/bussiness_policy_img3.png';
import bussiness_policy_img4 from '../../images/bussiness_policy_img4.png';
import bussiness_policy_img5 from '../../images/bussiness_policy_img5.png';
import bussiness_policy_img6 from '../../images/bussiness_policy_img6.png';
import NewsDetail from "../../common/NewsDetail/NewsDetail";
import AdBanner from "../../common/AdBanner/AdBanner";
import LatestNews from "../../common/LatestNews/LatestNews";
import ContentReserver from '../Content/contentReserve';


// const policyAnalyzListData=[
//     {key:0,type:'高新',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img1},
//     {key:1,type:'资金',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img2},
//     {key:2,type:'知识',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img3},
//     {key:3,type:'高新',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img4},
//     {key:4,type:'资金',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img5},
//     {key:5,type:'知识',title:'中国技术创业协会科技发... ',description:'中国技术创业协会科技财税服务联盟于2019年12月21日上午...',img:bussiness_policy_img6},
// ];

class BusinessScope extends Component{


    state={
        bussinessListHeight:0, //bussinessList组件的高度
        bussinessArticleData:null, //bussiness文章数据
    }

    constructor(props){
        super(props);
        this.onRouterUrlChange=this.onRouterUrlChange.bind(this);
        this.findBussinessDetailContent=this.findBussinessDetailContent.bind(this);
        this.onPolicyAnalyzCardItemClick=this.onPolicyAnalyzCardItemClick.bind(this);
        this.getNewsDescription=this.getNewsDescription.bind(this);
    }

    updateBussinessListHeight=(bussinessListHeight)=>{
        this.setState({
            bussinessListHeight:bussinessListHeight,
        })
    }

    updateBussinessArticleData=(bussinessArticleData)=>{
        this.setState({
            bussinessArticleData:bussinessArticleData,
        })
    }


    componentWillMount=()=>{
        this.props.fetch_bussinessList('get',null);
        this.props.fetch_bussiness_zxzx('get',null);

        let routerId=this.props.match.params.id;
        this.findBussinessDetailContent(routerId);
    }

    componentDidMount=()=>{
        this.props.fetch_policy('get',null);
        this.props.fetch_policy_type('get',null);
        window.addEventListener('hashchange',this.onRouterUrlChange);
    }

    onRouterUrlChange=()=>{
        let routerId=this.props.match.params.id;
        console.log('业务范围获取到得路由参数是:'+routerId)
        this.findBussinessDetailContent(routerId);
    }

    componentWillReceiveProps=()=>{
        // let routerId=this.props.match.params.id;
        // this.findPolicyDetailContent(routerId);
    }


    findBussinessDetailContent=(newsId)=>{

        if(newsId != null){
            let params={id:newsId};
            this.props.fetch_bussinessArticle('get',params)
        }


        // this.setState((state,props)=>({
        //     bussinessArticleData:props.bussinessArticleData,
        // }),()=>{
        //     console.log('更新后得state')
        //     console.log(this.state)
        // })
        setTimeout(()=>{
            this.setState({
                bussinessArticleData:this.props.bussinessArticleData,
            })
        },400)

        // this.props.itemConData.map((item)=>{
        //     if(newsId==item.id){
        //         this.setState({
        //             bussinessArticleData:item.title,
        //         })
        //     }
        // });
    }

    // 页面底部政策咨询的新闻Card的item点击事件。
    onPolicyAnalyzCardItemClick=(id)=>{
        // if(id != null){

        //     this.setState({
        //         isShowDetail:true,
        //         isShowXQTSNews:false,
        //     })

        // }
        window.scrollTo(0,400)
        // 开始跳转到政策新闻详情页
        this.props.history.push('/policy/detail_policy/'+id);
    }

    // 点击更多时的响应事件
    onMoreClick=(typeId)=>{
        // alert('点击的类型id是'+typeId)
        // this.setState({
        //     isShowDetail:false,
        //     isShowXQTSNews:false,
        // })
        window.scrollTo(0,400)
        this.props.history.push('/policy/more/'+typeId);

    }

    getNewsDescription=(contentHtmlStr)=>{
        let htmlReg=new RegExp('<[^<>]+>','g');
        let pureText=contentHtmlStr!=null?contentHtmlStr.replace(htmlReg,''):null;
        // contentText 内容文本
        let len=100; //要截取的长度
        if (pureText!=''&& pureText!=null){
            len=pureText.length < len? pureText.length:len;
            return pureText.substring(0,len)+'...';
        }
        return null;
    }


    render(){
        // console.log('在bussinessScope查看props')
        // console.log(this.props)

        let zxzxListData=[];
        this.props.bussiness_zxzx_data.map(({id,title,cover_link},index)=>{
            let obj={key:index,id:id,title:title,img:cover_link};
            zxzxListData.push(obj)
        });

        let policyAnalyzListData=[];
        if(this.props.policyData!=undefined){
            this.props.policyData.map((item,index)=>{
                let type=undefined;
                if(item.cate_desc.includes('高新'))
                    type='高新'
                else if(item.cate_desc.includes('资金'))
                    type='资金'
                else if(item.cate_desc.includes('知识'))
                    type='知识'
                else if(item.cate_desc.includes('资讯'))
                    type='资讯'

                let obj={id:item.id,type:type,title:item.title,description:this.getNewsDescription(item.content),img:item.cover_link}
                if(obj.type!=undefined)
                    policyAnalyzListData.push(obj)
                
            });
        }


        return(
            <div className={BusinessScopeSty.pageSty}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <LeftBussinessList parent={this} bussinessListData={this.props.bussinessListData}/>
                        <div style={{height: 16}}/>
                        <LatestNews/>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column',marginLeft: '24px'}}>
                        <div style={{minHeight:'1315px',backgroundColor:'#FFF'}}>
                            <NewsDetail url="/api/Business" hideHeader />
                        </div>
                        <div style={{height: 16}}/>
                        <AdBanner width={904} height={113}/>
                        {/* <div className={BusinessScopeSty.policyAnalyzDivSty}>
                            <PolicyAnalyzeCard className={BusinessScopeSty.policyAnalyzSty} PolicyListData={policyAnalyzListData} onItemClick={this.onPolicyAnalyzCardItemClick} onMoreClick={()=>{this.onMoreClick(this.props.policyTypeData[0]!=null?this.props.policyTypeData[0].id:0)}}/>
                        </div> */}
                        
                    </div>
                </div>
                <div style={{marginTop:'16px',width:'100%'}}>
                    <ContentReserver />
                </div>
            </div>
        );

    }
}

BusinessScope.propTypes={
    bussinessListData:PropTypes.array,
    itemConData:PropTypes.array,
}

const mapStateToProps=(state)=>{
    return {
        bussinessListData:state.bussinessReducer.bussiness_list_data,
        itemConData:state.bussinessReducer.bussiness_con_data,
        bussiness_zxzx_data:state.bussinessReducer.bussiness_zxzx_data,
        bussinessArticleData:state.bussinessReducer.bussiness_article_data,
        policyTypeData:state.aboutPolicyReducer.policyTypeData,
        policyData:state.aboutPolicyReducer.policyData,
    }
}

const mapDispatchToProps=(dispatch)=>{
    return {
        fetch_bussinessList:(method,params)=>{dispatch(fetch_bussinessList(method,params))},
        fetch_bussiness_zxzx:(method,params)=>{dispatch(fetch_bussiness_zxzx(method,params))},
        fetch_bussinessArticle:(method,params)=>{dispatch(fetch_bussiness_article(method,params))},
        fetch_policy_type:(method,params)=>{dispatch(fetch_policy_type(method,params))},
        fetch_policy:(method,params)=>{dispatch(fetch_policy(method,params))},
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(BusinessScope);
